import { Formik, Form } from "formik";
import * as Yup from "yup";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import InputFormik from "../../../../common/components/form/InputFormik";
import { maskCPF } from "../../../../common/helpers/mask.helpers";
import { isCPF } from "../../../../common/helpers/is-cpf";

// Esquema de validação com Yup
const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Nome é obrigatório.")
    .test(
      "full-name",
      "Deve incluir pelo menos um nome e um sobrenome",
      (value) => {
        if (!value) return false;
        const words = value.trim().split(/\s+/); // Divide a string por um ou mais espaços
        if (words.length < 2) return false; // Verifica se há pelo menos duas palavras

        // Verifica se cada palavra contém pelo menos uma letra alfabética
        return words.every((word) => /[a-zA-Z]/.test(word));
      }
    ),
  cpf: Yup.string()
    .required("CPF é obrigatório")
    .test("valida-cpf", "CPF inválido", (value) => isCPF(value)),
});

type FormPropsCreateRenter = {
  onSubmit: (values: { name: string; cpf: string; groupName: string }) => void;
};

function FormCreateRenter(props: FormPropsCreateRenter) {
  const initialValues = {
    name: "",
    cpf: "",
    groupName: JSON.parse(localStorage.selectedCompanies)[0]?.city,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    await props.onSubmit(values);
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleSubmit }) => (
        <Form>
          <InputFormik
            label="Nome completo:"
            name="name"
            className="w-full"
            required={true}
          />
          <InputFormik
            label="Informe o CPF:"
            name="cpf" // Certifique-se de que o nome do campo esteja consistente
            mask={maskCPF}
          />
          <div className="flex justify-end">
            <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}>
              Enviar
            </ButtonWithLoader>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default FormCreateRenter;
